import { useCallback } from 'react';

import { useLocale } from 'state/intl';
import { usePageManagerContext } from 'state/static-page-manager';
import { getInCodeLocalizedRouteForPath, getStaticPagesLocalizedRouteForPath } from 'utils/routing';

export default function useRoutes() {
  const { language } = useLocale();
  const { routes: staticRoutes } = usePageManagerContext();

  const getLocalizedRouteForPath = useCallback(
    (path: string): string => {
      const relativePath = path[0] === '/' ? path : `/${path}`;

      const localizedInCodePath = getInCodeLocalizedRouteForPath(relativePath);
      if (localizedInCodePath) {
        return localizedInCodePath;
      }

      const localizedRelativePath = relativePath;

      const localizedStaticPagesPath = getStaticPagesLocalizedRouteForPath(
        path,
        staticRoutes,
        language
      );

      return localizedStaticPagesPath || localizedRelativePath || '';
    },
    [language, staticRoutes]
  );

  return {
    getLocalizedRouteForPath,
  };
}
